import React, { useState, useEffect } from "react";
import axios from "axios";
import { UserRound } from "lucide-react";
import { NGROK } from "../../../../APIs";
import SelectionFeedback from "./SelectionFeedback";

const UserSelection = ({
  activeUsersList,
  setActiveUsersList,
  activeDevicesList,
  selectedTenantName,
}) => {
  const [usersList, setUsersList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError(false);
    const getUsersList = async () => {
      try {
        const users = await Promise.all(
          activeDevicesList.map(async (device) => {
            const response = await axios.get(
              `${NGROK}/api/${selectedTenantName}/computer-users/${device.id}`,
            );
            return response.data.content;
          }),
        );
        if (mounted) setUsersList(users.flat());
      } catch (error) {
        console.error(error);
        if (mounted) {
          setUsersList([]);
          setError(true);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };
    getUsersList();
    return () => {
      mounted = false;
    };
  }, [activeDevicesList, selectedTenantName]);

  if (loading || error || !usersList.length)
    return (
      <SelectionFeedback
        loading={loading}
        error={error}
        title={error ? "Unable to load users" : "No users available"}
        description={
          error
            ? "Go back and select your devices again to retry."
            : "No users were returned for these devices. Go back to review your device selection."
        }
      />
    );

  return (
    <div className="op-choice-grid">
      {usersList.map((user) => {
        const selected = activeUsersList.some((item) => item.id === user.id);
        return (
          <label
            key={user.id}
            className={`op-choice ${selected ? "is-selected" : ""}`}
          >
            <input
              type="checkbox"
              checked={selected}
              onChange={() =>
                setActiveUsersList((previous) =>
                  selected
                    ? previous.filter((item) => item.id !== user.id)
                    : [...previous, user],
                )
              }
            />
            <UserRound aria-hidden="true" />
            <span>
              <strong>{user.cn}</strong>
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default UserSelection;
